import { z } from "zod";
import { TENANT_AUTH_PROVIDERS } from "../constants.js";
const providerConfigSchema = z.record(z.unknown());
const activationFlagsBaseSchema = z.object({
    enabled: z.boolean().optional(),
    enforceSignIn: z.boolean().optional(),
    allowLocalFallback: z.boolean().optional(),
});
const activationFlagsSchema = activationFlagsBaseSchema.superRefine((value, ctx) => {
    if (value.enabled === false && value.enforceSignIn === true) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Cannot enforce sign-in while the provider is disabled",
            path: ["enforceSignIn"],
        });
    }
});
export const tenantAuthProviderParamSchema = z.enum(TENANT_AUTH_PROVIDERS);
export const upsertTenantAuthProviderSchema = activationFlagsBaseSchema.extend({
    providerConfig: providerConfigSchema.optional(),
}).superRefine((value, ctx) => {
    if (value.enabled === false && value.enforceSignIn === true) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Cannot enforce sign-in while the provider is disabled",
            path: ["enforceSignIn"],
        });
    }
});
export const updateTenantAuthProviderActivationSchema = activationFlagsSchema
    .refine((value) => Object.keys(value).length > 0, {
    message: "At least one activation flag must be provided",
});
//# sourceMappingURL=tenant-auth-provider.js.map